import { application } from './application'
import HwComboboxController from '@josefarias/hotwire_combobox'
import ClipboardController from './clipboard_controller.js'
import DialogController from './../controllers/dialog_controller.js'
import RedirectCountdownController from './redirect_countdown_controller.js'
import ScrollHintController from './scroll_hint_controller.js'
import VisitorTimeZoneController from './visitor_time_zone_controller.js'

application.register('hw-combobox', HwComboboxController)
application.register('clipboard', ClipboardController)
application.register('dialog', DialogController)
application.register('redirect-countdown', RedirectCountdownController)
application.register('scroll-hint', ScrollHintController)
application.register('visitor-time-zone', VisitorTimeZoneController)
